// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container-content {
  padding-top: 8rem;
  padding-left: 5rem;
  padding-right: 5rem;
  width: 100%;
  margin-bottom: 3rem;
}

.container-content h1 {
  text-align: center;
  font-size: 2.4rem;
  font-weight: 500;
  padding-bottom: 2rem;
  color: var(--txt);
}

.container-content #not-found-img{
  width: 100%;
  display: flex;
  justify-content: center;

}

.container-content .not-found-container{
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: 1.1rem;
}

.container-content p{
  font-size: 2rem;
  font-weight: 500;
  color: var(--txt);
}

.container-content #goBackBtn{
  background-color: var(--variant-1);
  border: none;
  font-size: 1.1rem;
  width: 120px;
  height: 54px;
  color: #fff;
}

.container-content h1 span {
  color: var(--variant-2);
}

.container-content .inside-content {
  padding-top: 4rem;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 4rem;
  flex-wrap: wrap;
}

.item-content {
  overflow: hidden;
  width: 20%;
  border-radius: 10px 10px 10px 10px;
  position: relative;
  text-decoration: none;
}

.item-content:hover #rest-name{
  color: var(--variant-1);
  transition: 0.2s;
}

.item-content img {
  width: 100%;
  height: 290px;
  margin-bottom: 0.1rem;
  object-fit: cover;
  object-position: center;
}

.item-description {
  padding: 1rem 1.5rem 2rem 1.5rem;
}

.item-content #loc {
  font-size: 0.9rem;
  padding-bottom: 0.5rem;
  color: #b4b4b3;
  align-items: center;
  display: flex;
  gap: 0.5rem;
}

.item-content #loc svg{
  font-size: 0.8rem;
  fill: #b4b4b3;
}

.item-content .rating-class {
  position: absolute;
  top: 45%;
  left: 0;
  box-shadow: rgba(0, 0, 0, 0.15) 1.95px 1.95px 2.6px;
  
}

.item-content .rating-class #rate{
  background-color: var(--variant-1);
  color: #fff;
  padding: 0.5rem 0.9rem 0.5rem 0.5rem;
  font-weight: 700;
  display: flex;
  align-items: center;
  gap: 1rem;
  font-size: 1.1rem;
}

.item-content .rating-class svg{
  fill: #fff;
}

.item-content #line-tag{
  margin-bottom: 1rem;
}

.item-content #rest-name {
  font-size: 1.4rem;
  font-weight: 700;
  text-decoration: none;
  color: var(--txt);
  padding-bottom: 24px;
}

.item-content #desc {
  text-align: justify;
  max-height: 120px;
  overflow: hidden;
  padding-top: 0.5rem;
  /* text-overflow: ellipsis; */
  display: -webkit-box;
  -webkit-line-clamp: 4;
  -webkit-box-orient: vertical;
  font-size: 1rem;
  color: #515151;
}

#load-more{
  margin-top: 1rem;
  border: none;
  background-color: var(--variant-1);
  color: #fff;
  width: 150px;
  height: 50px;
  font-size: 1.5rem;
  cursor: pointer;
}

#line-tag{
  color: #000;
}`, "",{"version":3,"sources":["webpack://./src/styles/cards.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,uBAAuB;;AAEzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,kCAAkC;EAClC,YAAY;EACZ,iBAAiB;EACjB,YAAY;EACZ,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,kCAAkC;EAClC,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,qBAAqB;EACrB,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,iBAAiB;EACjB,sBAAsB;EACtB,cAAc;EACd,mBAAmB;EACnB,aAAa;EACb,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,OAAO;EACP,mDAAmD;;AAErD;;AAEA;EACE,kCAAkC;EAClC,WAAW;EACX,oCAAoC;EACpC,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;EACrB,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,6BAA6B;EAC7B,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,kCAAkC;EAClC,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,WAAW;AACb","sourcesContent":[".container-content {\n  padding-top: 8rem;\n  padding-left: 5rem;\n  padding-right: 5rem;\n  width: 100%;\n  margin-bottom: 3rem;\n}\n\n.container-content h1 {\n  text-align: center;\n  font-size: 2.4rem;\n  font-weight: 500;\n  padding-bottom: 2rem;\n  color: var(--txt);\n}\n\n.container-content #not-found-img{\n  width: 100%;\n  display: flex;\n  justify-content: center;\n\n}\n\n.container-content .not-found-container{\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-direction: column;\n  gap: 1.1rem;\n}\n\n.container-content p{\n  font-size: 2rem;\n  font-weight: 500;\n  color: var(--txt);\n}\n\n.container-content #goBackBtn{\n  background-color: var(--variant-1);\n  border: none;\n  font-size: 1.1rem;\n  width: 120px;\n  height: 54px;\n  color: #fff;\n}\n\n.container-content h1 span {\n  color: var(--variant-2);\n}\n\n.container-content .inside-content {\n  padding-top: 4rem;\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  align-items: center;\n  gap: 4rem;\n  flex-wrap: wrap;\n}\n\n.item-content {\n  overflow: hidden;\n  width: 20%;\n  border-radius: 10px 10px 10px 10px;\n  position: relative;\n  text-decoration: none;\n}\n\n.item-content:hover #rest-name{\n  color: var(--variant-1);\n  transition: 0.2s;\n}\n\n.item-content img {\n  width: 100%;\n  height: 290px;\n  margin-bottom: 0.1rem;\n  object-fit: cover;\n  object-position: center;\n}\n\n.item-description {\n  padding: 1rem 1.5rem 2rem 1.5rem;\n}\n\n.item-content #loc {\n  font-size: 0.9rem;\n  padding-bottom: 0.5rem;\n  color: #b4b4b3;\n  align-items: center;\n  display: flex;\n  gap: 0.5rem;\n}\n\n.item-content #loc svg{\n  font-size: 0.8rem;\n  fill: #b4b4b3;\n}\n\n.item-content .rating-class {\n  position: absolute;\n  top: 45%;\n  left: 0;\n  box-shadow: rgba(0, 0, 0, 0.15) 1.95px 1.95px 2.6px;\n  \n}\n\n.item-content .rating-class #rate{\n  background-color: var(--variant-1);\n  color: #fff;\n  padding: 0.5rem 0.9rem 0.5rem 0.5rem;\n  font-weight: 700;\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n  font-size: 1.1rem;\n}\n\n.item-content .rating-class svg{\n  fill: #fff;\n}\n\n.item-content #line-tag{\n  margin-bottom: 1rem;\n}\n\n.item-content #rest-name {\n  font-size: 1.4rem;\n  font-weight: 700;\n  text-decoration: none;\n  color: var(--txt);\n  padding-bottom: 24px;\n}\n\n.item-content #desc {\n  text-align: justify;\n  max-height: 120px;\n  overflow: hidden;\n  padding-top: 0.5rem;\n  /* text-overflow: ellipsis; */\n  display: -webkit-box;\n  -webkit-line-clamp: 4;\n  -webkit-box-orient: vertical;\n  font-size: 1rem;\n  color: #515151;\n}\n\n#load-more{\n  margin-top: 1rem;\n  border: none;\n  background-color: var(--variant-1);\n  color: #fff;\n  width: 150px;\n  height: 50px;\n  font-size: 1.5rem;\n  cursor: pointer;\n}\n\n#line-tag{\n  color: #000;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
